import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SelectOption } from '@shared/models/multiselect-options.model';

export const voivodeshipListActions = createActionGroup({
    source: 'Voivodeship List',
    events: {
        'Get Voivodeship List': emptyProps(),
        'Get Voivodeship List Success': props<{ payload: SelectOption[] }>(),
        'Get Voivodeship List Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
